"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
var BaseAppView_1 = require("@shared/views/BaseAppView");
var models_1 = require("@shared/models");
var firebase_1 = __importDefault(require("firebase"));
var Register = /** @class */ (function (_super) {
    __extends(Register, _super);
    function Register() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.displayName = '';
        _this.email = '';
        _this.password = '';
        _this.state = 'not set';
        _this.inviteCode = '';
        _this.registering = false;
        return _this;
    }
    Register.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result, err_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        firebase_1.default.auth().onAuthStateChanged(function (user) {
                            if (user) {
                                _this.$router.push({ name: 'home' });
                            }
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        if (this.settings.requireInviteForSignup && !this.$route.query.code) {
                            this.state = 'uninvited';
                            return [2 /*return*/];
                        }
                        this.inviteCode = this.$route.query.code.toString();
                        return [4 /*yield*/, this.$api.invitationService.check(this.$route.query.code.toString())];
                    case 2:
                        result = _a.sent();
                        this.state = result.isClaimed ? 'claimed' : 'valid';
                        return [3 /*break*/, 5];
                    case 3:
                        err_1 = _a.sent();
                        this.errorMessage = 'SkateLurker is currently set to invite only while we get things ready for production. Sorry for the delay.';
                        this.state = 'error';
                        return [3 /*break*/, 5];
                    case 4:
                        this.loading = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    Register.prototype.register = function () {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var user, result, err_2;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 3, 4, 5]);
                        this.registering = true;
                        user = new models_1.UserCreateRequest({ email: this.email, displayName: this.displayName, password: this.password, invitationCode: this.inviteCode });
                        return [4 /*yield*/, this.$api.userService.signup(user)];
                    case 1:
                        result = _c.sent();
                        return [4 /*yield*/, firebase_1.default.auth().signInWithEmailAndPassword(this.email, this.password)];
                    case 2:
                        _c.sent();
                        this.$router.push({ name: 'login' });
                        this.notification.success('Thank you for signing up for SkateLurker!');
                        return [3 /*break*/, 5];
                    case 3:
                        err_2 = _c.sent();
                        if ((_b = (_a = err_2.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.detail) {
                            this.notification.error(err_2.response.data.detail);
                        }
                        else {
                            this.notification.error('An error occurred while registering your account');
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        this.loading = false;
                        this.registering = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    Register = __decorate([
        vue_property_decorator_1.Component({})
    ], Register);
    return Register;
}(BaseAppView_1.BaseAppView));
exports.default = Register;
